
class ModularProductOverview {
  constructor() {
    this.init();
  }

  init() {
  if (!document.querySelector('.modular-product-overview')) {
    return;
  }

    this.initDesktopTabs();
    this.initMobileAccordion();
    this.initPlayIconOverlays();
  }

  initDesktopTabs() {
  const tabButtons = document.querySelectorAll('.modular-tab-button');
  const tabPanels = document.querySelectorAll('.modular-tab-panel');
  
  tabButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleTabClick(e, tabButtons, tabPanels));
      button.addEventListener('keydown', (e) => this.handleTabKeydown(e, tabButtons));
    });
  }

  handleTabClick(event, tabButtons, tabPanels) {
    const targetTab = event.currentTarget.getAttribute('data-tab');
      
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });
      
      tabPanels.forEach(panel => {
        panel.classList.remove('active');
      });
    event.currentTarget.classList.add('active');
    event.currentTarget.setAttribute('aria-selected', 'true');
    event.currentTarget.setAttribute('tabindex', '0');
      
      const targetPanel = document.getElementById(targetTab + '-panel');
      if (targetPanel) {
        targetPanel.classList.add('active');
        this.loadLazyContent(targetPanel);
      
      if (targetTab === 'key-ingredients') {
        setTimeout(() => {
          this.initializeIngredientsSliders();
        }, 100);
      }
    }
  }

  handleTabKeydown(event, tabButtons) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      const currentIndex = Array.from(tabButtons).indexOf(event.currentTarget);
      const direction = event.key === 'ArrowLeft' ? -1 : 1;
        const nextIndex = (currentIndex + direction + tabButtons.length) % tabButtons.length;
        tabButtons[nextIndex].focus();
        tabButtons[nextIndex].click();
      }
  }

  initMobileAccordion() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  
  accordionHeaders.forEach(header => {
      header.addEventListener('click', (e) => this.handleAccordionClick(e));
    });
  }

  handleAccordionClick(event) {
    const isExpanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
    const targetContent = document.getElementById(event.currentTarget.getAttribute('aria-controls'));
    const plusIcon = event.currentTarget.querySelector('.icon-plus');
    const minusIcon = event.currentTarget.querySelector('.icon-minus');
      if (isExpanded) {
        event.currentTarget.classList.remove('active');
        event.currentTarget.setAttribute('aria-expanded', 'false');
          targetContent.classList.remove('active');
          if (plusIcon && minusIcon) {
            plusIcon.style.display = 'block';
            minusIcon.style.display = 'none';
          }
      } else {
        event.currentTarget.classList.add('active');
        event.currentTarget.setAttribute('aria-expanded', 'true');
        targetContent.classList.add('active');
        this.loadLazyContent(targetContent);
        if (plusIcon && minusIcon) {
          plusIcon.style.display = 'none';
          minusIcon.style.display = 'block';
        }
      
      if (event.currentTarget.id === 'mobile-key-ingredients-header') {
        setTimeout(() => {
          this.initializeIngredientsSliders();
        }, 100);
      }
    }
  }

  initPlayIconOverlays() {
  const playIconOverlays = document.querySelectorAll('.play-icon-overlay');
  
  playIconOverlays.forEach((overlay, index) => {
    const videoUrl = overlay.getAttribute('data-video-url');
    const videoWrapper = overlay.closest('.video-wrapper');
    
    if (videoUrl && videoWrapper) {
        overlay.addEventListener('click', () => this.handlePlayIconClick(overlay, videoUrl, videoWrapper));
        overlay.addEventListener('keydown', (e) => this.handlePlayIconKeydown(e, overlay));
      }
    });
  }

  handlePlayIconClick(overlay, videoUrl, videoWrapper) {
        const video = videoWrapper.querySelector('video');
        
        if (video) {
          const sources = video.querySelectorAll('source[data-src]');
          sources.forEach(source => {
            if (source.dataset.src && !source.src) {
              source.src = source.dataset.src;
            }
          });
          
          video.controls = true;
          video.setAttribute('preload', 'metadata');
          video.load();
          
          overlay.style.display = 'none';
          
          videoWrapper.classList.add('playing');
          
          video.play().catch(error => {
            console.log('Video autoplay failed:', error);
          });
          
          video.addEventListener('pause', () => {
            overlay.style.display = 'flex';
            videoWrapper.classList.remove('playing');
          });
          
          video.addEventListener('ended', () => {
            overlay.style.display = 'flex';
            videoWrapper.classList.remove('playing');
          });
        }
  }

  handlePlayIconKeydown(event, overlay) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      overlay.click();
    }
  }

  initializeIngredientsSliders() {
    const ingredientsContainers = document.querySelectorAll('.ingredients-container');
    
    ingredientsContainers.forEach(container => {
      if (container.offsetHeight > 0 && container.offsetWidth > 0) {
        new IngredientsSlider(container);
      }
    });
  }

  initializeOnLoad() {
    const activeKeyIngredientsPanel = document.querySelector('#key-ingredients-panel.active');
    const activeMobileKeyIngredients = document.querySelector('#mobile-key-ingredients.active');
    
    if (activeKeyIngredientsPanel || activeMobileKeyIngredients) {
      requestAnimationFrame(() => {
        this.initializeIngredientsSliders();
        this.loadLazyContent(activeKeyIngredientsPanel || activeMobileKeyIngredients);
      });
    }

    const activePanels = document.querySelectorAll('.modular-tab-panel.active, .accordion-content.active');
    activePanels.forEach(panel => {
      this.loadLazyContent(panel);
    });
    
    this.initializeLazyLoading();
  }

  initializeLazyLoading() {
    if (this.tabButtons && this.tabButtons.length > 0) {
      this.tabButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          const tabName = e.target.dataset.tab;
          const panel = document.querySelector(`#${tabName}-panel`);
          if (panel) {
            this.loadLazyContent(panel);
          }
        });
      });
    }

    if (this.accordionHeaders && this.accordionHeaders.length > 0) {
      this.accordionHeaders.forEach(header => {
        header.addEventListener('click', (e) => {
          const content = e.target.nextElementSibling;
          if (content) {
            this.loadLazyContent(content);
          }
        });
      });
    }
  }

  loadLazyContent(container) {
    if (!container) return;

    const lazyImages = container.querySelectorAll('.lazy-image[data-src]');
    lazyImages.forEach(img => {
      if (img.dataset.src && !img.src) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
        img.classList.add('loaded');
        img.classList.remove('lazy-image');
      }
    });

    const lazyVideos = container.querySelectorAll('video[data-lazy-load]');
    lazyVideos.forEach(video => {
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach(source => {
        if (source.dataset.src && !source.src) {
          source.src = source.dataset.src;
        }
      });
      video.setAttribute('preload', 'metadata');
      video.load();
      
      video.addEventListener('loadedmetadata', () => {
        video.classList.add('video-ready');
      });
    });

    const allVideos = container.querySelectorAll('video');
    allVideos.forEach(video => {
      const sources = video.querySelectorAll('source[data-src]');
      if (sources.length > 0) {
        sources.forEach(source => {
          if (source.dataset.src && !source.src) {
            source.src = source.dataset.src;
          }
        });
        video.setAttribute('preload', 'metadata');
        video.load();
        
        video.addEventListener('loadedmetadata', () => {
          video.classList.add('video-ready');
        });
      }
    });

    const lazyMedia = container.querySelector('[data-lazy-load]');
    if (lazyMedia) {
      lazyMedia.removeAttribute('data-lazy-load');
    }

    if (container.id === 'key-ingredients-panel' || container.id === 'mobile-key-ingredients') {
      setTimeout(() => {
        this.initializeIngredientsSliders();
      }, 100);
    }
  }
}

class IngredientsSlider {
  constructor(container) {
    this.container = container;
    this.navPrev = container.querySelector('.ingredients-nav--prev');
    this.navNext = container.querySelector('.ingredients-nav--next');
    this.grid = container.querySelector('.ingredients-grid');
    
    if (!this.navPrev || !this.navNext || !this.grid || container.classList.contains('grid-layout')) {
      return;
    }
    
    if (container.offsetHeight === 0 || this.grid.children.length === 0) {
      setTimeout(() => new IngredientsSlider(container), 200);
      return;
    }
    
    this.currentScroll = 0;
    this.scrollAmount = 0;
    
    this.init();
  }

  init() {
    this.grid.scrollLeft = 0;
    this.currentScroll = 0;
    
    this.calculateScrollAmount();
    this.bindEvents();
    this.updateButtonStates();
    this.waitForImages();
  }

  calculateScrollAmount() {
    const firstCard = this.grid.querySelector('.ingredient-card');
    const screenWidth = window.innerWidth;
    
    if (firstCard) {
      const cardWidth = firstCard.offsetWidth;
      const gap = parseFloat(getComputedStyle(this.grid).gap) || 0;
      
      this.scrollAmount = cardWidth + gap;
    } else {
      const containerWidth = this.grid.clientWidth;
      
      let itemsVisible;
      if (screenWidth >= 992) {
        itemsVisible = 5;
      } else if (screenWidth >= 768) {
        itemsVisible = 4;
      } else {
        itemsVisible = 2;
      }
      
      this.scrollAmount = containerWidth / itemsVisible;
    }
  }

  bindEvents() {
    this.navPrev.addEventListener('click', () => this.scrollLeft());
    this.navNext.addEventListener('click', () => this.scrollRight());
    this.grid.addEventListener('scroll', () => this.handleScroll());
    
    window.addEventListener('resize', () => {
      this.calculateScrollAmount();
      setTimeout(() => this.updateButtonStates(), 100);
    });
  }

  scrollLeft() {
    if (this.navPrev.disabled) return;
    
    this.currentScroll = Math.max(0, this.currentScroll - this.scrollAmount);
    this.grid.scrollTo({
      left: this.currentScroll,
      behavior: 'smooth'
    });
    
    setTimeout(() => this.updateButtonStates(), 150);
  }

  scrollRight() {
    if (this.navNext.disabled) return;
    
    const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
    const targetScroll = this.currentScroll + this.scrollAmount;
    
    // Ensure we don't scroll past the maximum
    this.currentScroll = Math.min(maxScroll, targetScroll);
    
    this.grid.scrollTo({
      left: this.currentScroll,
      behavior: 'smooth'
    });
    
    setTimeout(() => this.updateButtonStates(), 150);
  }

  handleScroll() {
    this.currentScroll = this.grid.scrollLeft;
    this.updateButtonStates();
  }

  updateButtonStates() {
    this.grid.offsetHeight;
    
    if (this.grid.scrollWidth === 0 || this.grid.clientWidth === 0) {
      setTimeout(() => this.updateButtonStates(), 100);
      return;
    }
    
    const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
    
    this.currentScroll = this.grid.scrollLeft;
    
    const needsScrolling = maxScroll > 1;
    
    if (!needsScrolling) {
      this.navPrev.disabled = true;
      this.navPrev.setAttribute('aria-disabled', 'true');
      this.navNext.disabled = true;
      this.navNext.setAttribute('aria-disabled', 'true');
    } else {
      const isAtStart = this.currentScroll <= 1;
      const isAtEnd = this.currentScroll >= maxScroll - 1;
      
      if (isAtStart) {
        this.navPrev.disabled = true;
        this.navPrev.setAttribute('aria-disabled', 'true');
      } else {
        this.navPrev.disabled = false;
        this.navPrev.setAttribute('aria-disabled', 'false');
      }
      
      if (isAtEnd) {
        this.navNext.disabled = true;
        this.navNext.setAttribute('aria-disabled', 'true');
      } else {
        this.navNext.disabled = false;
        this.navNext.setAttribute('aria-disabled', 'false');
      }
    }
  }

  waitForImages() {
    const images = this.grid.querySelectorAll('img');
    if (images.length > 0) {
      let loadedImages = 0;
      images.forEach(img => {
        if (img.complete) {
          loadedImages++;
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) {
              this.calculateScrollAmount();
              setTimeout(() => this.updateButtonStates(), 50);
            }
          });
        }
      });
      
      if (loadedImages === images.length) {
        this.calculateScrollAmount();
        setTimeout(() => this.updateButtonStates(), 50);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const modularProductOverview = new ModularProductOverview();
  
  modularProductOverview.initializeOnLoad();
});